<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">
    <span class="primary hover" (click)="onBack()">Third parties applications</span>
    <i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
    Legacy image formats
  </div>
</div>

<div class="padding bg-orange">
  <i class="fa fa-info-circle margin-right-small"></i>
  For every confirmed
  <b>squared photo</b>
  , the legacy export generates one JPEG per active format and uploads it to
  <b>TCNIMG</b>
  . Changes apply to the photos exported from now on: files already on tcnimg stay as they are.
</div>

<div class="page-layout-small padding-large m-margin-none m-padding m-padding-top-largest">
  <bt-page-header title="Legacy image formats" subtitle="JPEG formats generated for TCNIMG by the legacy export" icon="fa fa-arrow-right-from-bracket"></bt-page-header>

  @if (formats.length) {
    <table class="desktop-only">
      <tr>
        <th>Code</th>
        <th>Description</th>
        <th>Size (px)</th>
        <th>Active</th>
        <th>Last update</th>
        <th>Action</th>
      </tr>
      @for (format of formats; track format.id) {
        <tr>
          <td>
            <b>{{ format.code }}</b>
          </td>
          <td>{{ format.description }}</td>
          <td>{{ format.width }} × {{ format.height }}</td>
          <td>
            @if (format.active) {
              <span class="bg-green white radius padding-left-smallest padding-right-smallest">Active</span>
            } @else {
              <span class="grey">Inactive</span>
            }
          </td>
          <td class="grey small">{{ format.updateDate | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td class="nowrap">
            <span class="hover primary flex center" (click)="openEditFormatModal(format)">
              <i class="fa-solid fa-edit small margin-right-smallest"></i>
              Edit
            </span>
          </td>
        </tr>
      }
    </table>

    <div class="mobile-only flex column gap">
      @for (format of formats; track format.id) {
        <div class="border radius padding margin-bottom-small flex column gap">
          <div class="flex center between">
            <b>{{ format.code }}</b>
            @if (format.active) {
              <span class="bg-green white radius padding-left-smallest padding-right-smallest">Active</span>
            } @else {
              <span class="grey">Inactive</span>
            }
          </div>
          <div>{{ format.description }}</div>
          <div>
            <b>Size (px):</b>
            {{ format.width }} × {{ format.height }}
          </div>
          <div class="grey small">
            <b>Last update:</b>
            {{ format.updateDate | date: 'dd/MM/yyyy HH:mm' }}
          </div>
          <div class="flex end">
            <span class="hover primary flex center" (click)="openEditFormatModal(format)">
              <i class="fa-solid fa-edit small margin-right-smallest"></i>
              Edit
            </span>
          </div>
        </div>
      }
    </div>
  }

  @if (!formats.length && !loading) {
    <div class="flex center bg-light-grey padding-largest justify-center">
      <div class="flex column center gap">
        <i class="fa fa-search fa-2xl margin-bottom grey"></i>
        <span>No data found</span>
      </div>
    </div>
  }
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
